import { render, staticRenderFns } from "./ItemSheet.vue?vue&type=template&id=37d9551a&"
import script from "./ItemSheet.vue?vue&type=script&lang=ts&"
export * from "./ItemSheet.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports